import { clone } from 'lodash';

const initState = {
  isFetching: false,
  openDialog: false,
  telemetryMetrics: [],
  checkedMetrics: [],
  error: null,
};

function telemetryMetrics(state = initState, action) {
  switch (action.type) {
    case 'CLEAR_STATE':
      return initState;
    case 'OPEN_TELEMETRY_METRICS_EDIT_DIALOG':
      return {
 ...state, openDialog: true, error: null, mode: action.mode,
};
    case 'CLOSE_TELEMETRY_METRICS_EDIT_DIALOG':
      return { ...state, openDialog: false };
    case 'TELEMETRY_METRICS_REQUEST_SUCCESS':
      return { ...state, isFetching: false, openDialog: false };
    case 'TELEMETRY_METRICS_REQUEST_ERROR':
      return { ...state, isFetching: false, error: action.message };
    case 'STOP_FETCHING_TELEMETRY_METRICS':
      return { ...state, isFetching: false };
    case 'TELEMETRY_METRICS_REQUEST':
      return { ...state, isFetching: true, error: null };

    case 'SET_TELEMETRY_METRICS':
      return { ...state, telemetryMetrics: action.metrics };
    case 'DESELECT_ALL_METRICS':
      return { ...state, checkedMetrics: [] };
    case 'TOGGLE_CHECKED_METRICS': {
      const isChecked = state.checkedMetrics.filter((checked) => (checked.uuid === action.metric.uuid)).length > 0;
      const checkedMetrics = isChecked
        ? state.checkedMetrics.filter((metric) => (metric.uuid !== action.metric.uuid))
        : [...state.checkedMetrics, clone(action.metric)]; // _clone is needed to avoid changing original store accounts

      return { ...state, checkedMetrics };
    }
    case 'TOGGLE_SELECT_ALL_METRICS': {
      let checkedMetricsII;
      const stateCheckedMetrics = state.checkedMetrics || [];
      // Check if all metrics on current page is checked
      const allSelected = stateCheckedMetrics
        .filter((checked) => (state.telemetryMetrics.filter((metric) => (checked.uuid === metric.uuid)).length > 0))
        .length === state.telemetryMetrics.length;

      if (allSelected) {
        // Filter checked accounts to exclude accounts from current page
        checkedMetricsII = stateCheckedMetrics
          .filter((checked) => (state.telemetryMetrics.filter((metric) => (metric.uuid === checked.uuid)).length === 0));
      } else {
        // Find accounts which is not selected yet
        const notSelected = state
          .telemetryMetrics
          .filter((metric) => (stateCheckedMetrics.filter((checked) => (checked.uuid === metric.uuid)).length === 0));

        // And add them to checked array
        checkedMetricsII = [...stateCheckedMetrics, ...notSelected];
      }

      return { ...state, checkedMetrics: checkedMetricsII };
    }

    default:
      return state;
  }
}

export default telemetryMetrics;
